import React from 'react'
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function BlogSlider() {
    var settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1064,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
  return (
    <div>
    <section className="section-padding our_articles">
      <div className="container">
        <div className="section-header text-center">
          <div className="section-heading">
            <h3 className="text-custom-black">Our <span className="text-custom-blue">Blog</span></h3>
            <div className="section-description">
              <p className="text-light-dark">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Slider {...settings} className="blog-slider arrow-layout-2 row"> 
              <article className="col-12 post slide-item">
                <div className="post-wrapper bx-wrapper">
                  <div className="post-img animate-img"> <Link to="/blog-details"> <img src="/tm/react/bycycle/assets/images/blog/blog-1.jpg" className="full-width" alt="img"/> </Link>
                  </div>
                  <div className="blog-meta padding-20 bg-custom-white p-relative">
                    <div className="post-meta mb-xl-20"> <Link to="/blog-details" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 10 Comments </Link> <Link to="/blog-details" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 2 Likes </Link> </div>
                    <div className="post-heading">
                      <h2> <Link to="/blog-details" className="text-custom-black fw-600 fs-20">SURVIVE BIKE ROAD TRIPS</Link> </h2>
                      <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                    </div>
                  </div>
                  <div className="post-footer">
                    
                    <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
                </div>
              </article>
              {/* <!-- article --> 
              <!-- article --> */}
              <article className="col-12 post slide-item">
                <div className="post-wrapper bx-wrapper">
                  <div className="post-img animate-img"> <Link to="/blog-details"> <img src="/tm/react/bycycle/assets/images/blog/blog-2.jpg" className="full-width" alt="img"/> </Link>
                  
                  </div>
                  <div className="blog-meta padding-20 bg-custom-white p-relative">
                    <div className="post-meta mb-xl-20"> <Link to="/blog-details" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 2 Comments </Link> <Link to="/blog-details" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 10 Likes </Link> </div>
                    <div className="post-heading">
                      <h2> <Link to="/blog-details" className="text-custom-black fw-600 fs-20">AN OVERVIEW ON BICYCLES</Link> </h2>
                      <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                    </div>
                  </div>
                  <div className="post-footer">
                    
                    <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
                </div>
              </article>
              {/* <!-- article --> 
              <!-- article --> */}
              <article className="col-12 post slide-item">
                <div className="post-wrapper bx-wrapper">
                  <div className="post-img animate-img"> <Link to="/blog-details"> <img src="/tm/react/bycycle/assets/images/blog/blog-3.jpg" className="full-width" alt="img"/> </Link>
                    
                  </div>
                  <div className="blog-meta padding-20 bg-custom-white p-relative">
                    <div className="post-meta mb-xl-20"> <Link to="/blog-details" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 3 Comments </Link> <Link to="/blog-details" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 5 Likes </Link> </div>
                    <div className="post-heading">
                      <h2> <Link to="/blog-details" className="text-custom-black fw-600 fs-20"> AN OVERVIEW ON BICYCLES</Link> </h2>
                      <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                    </div>
                  </div>
                  <div className="post-footer">
                  
                    <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
                </div>
              </article>
              {/* <!-- article --> 
              <!-- article --> */}
              <article className="col-12 post slide-item">
                <div className="post-wrapper bx-wrapper">
                  <div className="post-img animate-img"> <Link to="/blog-details"> <img src="/tm/react/bycycle/assets/images/blog/blog-4.jpg" className="full-width" alt="img"/> </Link>
                    
                  </div>
                  <div className="blog-meta padding-20 bg-custom-white p-relative">
                    <div className="post-meta mb-xl-20"> <Link to="/blog-details" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 3 Comments </Link> <Link to="/blog-details" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 20 Likes </Link> </div>
                    <div className="post-heading">
                      <h2> <Link to="/blog-details" className="text-custom-black fw-600 fs-20">AROUND NEW YORK BY BIKE!</Link> </h2>
                      <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                    </div>
                  </div>
                  <div className="post-footer">
                    
                    <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
                </div>
              </article>
            </Slider>
          </div>
        </div>
      </div>
    </section>
    </div>
  )
}

export default BlogSlider